





























































import Vue from "vue";
import Spinner from "../Spinner.vue";
import { AppAnalytics } from "@/analytics";

export default Vue.extend({
  components: { Spinner },
  props: {
    source: {
      type: Object,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    showActionsMenu: {
      type: Boolean,
      default: true,
    },
    actions: {
      type: Array,
      default: () => [],
    },
  },
  setup(_, { emit }) {
    const showMenu = ($event: MouseEvent) => {
      emit("showMenu", $event);
      AppAnalytics.report({
        component: "General",
        eventName: "Table row menu clicked",
      });
    };
    return {
      showMenu,
    };
  },
});
